import { render } from "./GPTComponent.vue?vue&type=template&id=6310eae5&scoped=true"
import script from "./GPTComponent.vue?vue&type=script&lang=js"
export * from "./GPTComponent.vue?vue&type=script&lang=js"

import "./GPTComponent.vue?vue&type=style&index=0&id=6310eae5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6310eae5"]])

export default __exports__